module.exports = fox._r("images/promo/tutorial/11.png", __webpack_public_path__ + "_/common/images/promo/tutorial/11.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/11.png
// module id = 659
// module chunks = 2